import React, { useState, useEffect, useContext } from "react";
import { getPriority } from "../../services/uiService.jsx";
import { ConfigContext } from "./../../context/ConfigContext";
//import "./../../../Mapi/styles/checksPopup.css";

const ChecksPopupForm = ({
  isFirstLoad,
  closePopup,
  isPopupOpen,
  D2_checksList,
  D3_advanced,
  D3_cmp,
  onSelectedCheckboxesChange,
}) => {
  const config = useContext(ConfigContext);

  const [activeTab, setActiveTab] = useState("Tab1");
  const [priority, setPriority] = useState(() => {
    const first_priority = getPriority(config.generalEndPoint) || 1;
    return first_priority;
  });
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({
    Tab1: {},
    Tab2: {},
    Tab3: {},
  });
  const [isPopupVisible, setIsPopupVisible] = useState(true);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  const toggleDescription = (index) => {
    setExpandedDescriptions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const saveSelectedRunsToLocalStorage = (selectedRuns) => {
    localStorage.setItem("selectedRuns", JSON.stringify(selectedRuns));
  };

  const getSelectedRunsFromLocalStorage = () => {
    const selectedRunsJSON = localStorage.getItem("selectedRuns");
    return selectedRunsJSON
      ? JSON.parse(selectedRunsJSON)
      : { Tab1: {}, Tab2: {}, Tab3: {} };
  };

  useEffect(() => {
    if (isFirstLoad) {
      setSelectedCheckboxes({
        Tab1: {},
        Tab2: {},
        Tab3: {},
      });
    } else {
      const savedSelectedRuns = getSelectedRunsFromLocalStorage();
      setSelectedCheckboxes(savedSelectedRuns);
    }
  }, []);

  useEffect(() => {
    return () => {
      saveSelectedRunsToLocalStorage(selectedCheckboxes);
    };
  }, [selectedCheckboxes]);

  const handleCheckboxChange = (tab, index) => {
    setSelectedCheckboxes((prevSelectedCheckboxes) => {
      const currentTabData = { ...prevSelectedCheckboxes[tab] };
      const isChecked = currentTabData[index];

      if (isChecked) {
        const deselectedPriority = currentTabData[index]?.priority;

        // Remove the deselected item
        delete selectedCheckboxes[tab][index];

        const updatedTab = Object.fromEntries(
          Object.entries(selectedCheckboxes)?.map(([tKey, tValue]) => {
            const updatedTabData = Object.fromEntries(
              Object.entries(tValue).map(([key, value]) => {
                if (value.priority > deselectedPriority) {
                  return [key, { ...value, priority: value.priority - 1 }];
                }
                return [key, value];
              })
            );
            return [tKey, updatedTabData];
          })
        );

        // Adjust priorities of items with higher priority in the current tab
        const updatedTabData = Object.fromEntries(
          Object.entries(currentTabData).map(([key, value]) => {
            if (value.priority > deselectedPriority) {
              return [key, { ...value, priority: value.priority - 1 }];
            }
            return [key, value];
          })
        );
        return updatedTab;
      } else {
        // Add the new item with the current priority
        return {
          ...prevSelectedCheckboxes,
          [tab]: {
            ...currentTabData,
            [index]: {
              isActive: true,
              priority,
            },
          },
        };
      }
    });

    // Update priority accordingly
    const isChecked = Object.keys(selectedCheckboxes[tab]).find(
      (c) => c === index
    );
    setPriority((prev) => (isChecked ? prev - 1 : prev + 1));
  };

  const handleSelectAll = () => {
    const currentTab = selectedCheckboxes[activeTab];
    const allSelected = Object.values(currentTab).every(
      (isSelected) => isSelected
    );
    const updatedSelectedCheckboxes = {};
    const list =
      activeTab === "Tab1"
        ? D2_checksList
        : activeTab === "Tab2"
        ? D3_advanced
        : D3_cmp;
    list.forEach((item, index) => {
      updatedSelectedCheckboxes[index] = !allSelected;
    });
    setSelectedCheckboxes({
      ...selectedCheckboxes,
      [activeTab]: updatedSelectedCheckboxes,
    });
  };

  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "a") {
      event.preventDefault();
      handleSelectAll();
    }
  };

  const renderContent = () => {
    const getItemDescription = (item, index) => (
      <div className="description-container">
        <label
          className="checkBoxDesc"
          htmlFor={`${activeTab}-checkboxDesc-${index}`}
        >
          {item.description}
        </label>
      </div>
    );

    const getItemSeverity = (item, index) => (
      <div className="severity-container">
        <label
          className="checkBoxSeverity"
          htmlFor={`${activeTab}-checkboxSeverity-${index}`}
        >
          {item.severity}
        </label>
      </div>
    );

    const getItems = (items) =>
      items?.map((item, index) => (
        <div key={item?.["checkNo"]} className="checkLine">
          <div className="fixed-checkbox-label">
            <input
              type="checkbox"
              id={`${activeTab}-checkbox-${item?.["checkNo"]}`}
              className="checksCheckBox"
              checked={
                selectedCheckboxes[activeTab][item?.["checkNo"]] || false
              }
              onChange={() =>
                handleCheckboxChange(activeTab, item?.["checkNo"])
              }
            />
            <label
              className="checkBoxLabel"
              htmlFor={`${activeTab}-checkbox-${item?.["checkNo"]}`}
            >
              {item?.["checkNo"]}
            </label>
          </div>
          {getItemSeverity(item, index)}
          {getItemDescription(item, index)}
        </div>
      ));

    switch (activeTab) {
      case "Tab1":
        return <div>{getItems(D2_checksList)}</div>;
      case "Tab2":
        return <div>{getItems(D3_advanced)}</div>;
      case "Tab3":
        return <div>{getItems(D3_cmp)}</div>;
      default:
        return null;
    }
  };

  const formClose = () => {
    setIsPopupVisible(false);
    // Call the provided closePopup function
    closePopup();
    // Call the callback function to pass selectedCheckboxes to the parent component
    onSelectedCheckboxesChange(selectedCheckboxes);
  };

  if (!isPopupVisible) {
    return null;
  }

  return (
    <div className="popup-overlay" tabIndex={0} onKeyDown={handleKeyDown}>
      <div className="popup">
        <div className="popup-header">
          <span className="popupTitle">בדיקות לפי בחירה</span>
          {/* <button onClick={formClose} className="close-btn">X</button> */}
        </div>
        <div className="tabs">
          <button
            onClick={() => setActiveTab("Tab3")}
            className={activeTab === "Tab3" ? "active" : ""}
          >
            בדיקות השוואה
          </button>
          <button
            onClick={() => setActiveTab("Tab2")}
            className={activeTab === "Tab2" ? "active" : ""}
          >
            בדיקות מתקדמות
          </button>
          <button
            onClick={() => setActiveTab("Tab1")}
            className={activeTab === "Tab1" ? "active" : ""}
          >
            בדיקות המרה
          </button>
        </div>
        <div className="content">{renderContent()}</div>

        <div className="buttons-bottom">
          <button className="continueButtonPopup" onClick={formClose}>
            סגור
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChecksPopupForm;
